<script>
import { ref, onMounted, watch } from 'vue';
import { useMutation, useQuery } from '@vue/apollo-composable';
import { gql } from '@apollo/client/core';

// GraphQL mutation to add a visitor to the Strapi database with status and visit count
const ADD_VISITOR = gql`
  mutation AddLead($phoneNumber: String!, $project: String!, $status: String!, $visitCount: Int!) {
    createLead(data: { phoneNumber: $phoneNumber, project: $project, status: $status, visitCount: $visitCount }) {
      data {
        id
        attributes {
          phoneNumber
          project
          status
          visitCount
        }
      }
    }
  }
`;

// GraphQL mutation to update a visitor's status and visit count in the Strapi database
const UPDATE_VISITOR = gql`
  mutation UpdateLead($id: ID!, $status: String!, $visitCount: Int!) {
    updateLead(id: $id, data: { status: $status, visitCount: $visitCount }) {
      data {
        id
        attributes {
          status
          visitCount
        }
      }
    }
  }
`;

// GraphQL query to check if a lead already exists in the database
const CHECK_EXISTENCE = gql`
  query CheckLead($phoneNumber: String!, $project: String!) {
    leads(filters: { phoneNumber: { eq: $phoneNumber }, project: { eq: $project } }) {
      data {
        id
        attributes {
          visitCount
        }
      }
    }
  }
`;

export default {
  name: 'HelloWorld',
  props: {
    phoneNumber: {
      type: String,
      required: true
    },
    projectKey: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const datetime = ref(new Date().toISOString());
    const showCookieWarning = ref(false);

    const { mutate: addVisitor } = useMutation(ADD_VISITOR);
    const { mutate: updateVisitor } = useMutation(UPDATE_VISITOR);
    const { result: leadExistence, loading: existenceLoading, error: existenceError } = useQuery(CHECK_EXISTENCE, {
      phoneNumber: props.phoneNumber.replaceAll("_",""),
      project: props.projectKey,
    });

    const logVisit = async () => {
      try {
        // Check if lead exists
        if (!existenceLoading.value && leadExistence.value && leadExistence.value.leads.data.length > 0) {
          const lead = leadExistence.value.leads.data[0];
          // Lead exists, update status and increment visit count
          await updateVisitor({
            id: lead.id,
            status: 'VD',
            visitCount: lead.attributes.visitCount + 1,
          });
          console.log('Visitor status updated to "VD" and visit count incremented.');
        } else {
          // Lead doesn't exist, create new with status 'NEW' and visit count 1
          await addVisitor({
            phoneNumber: props.phoneNumber.replaceAll("_",""),
            project: props.projectKey,
            status: 'NEW',
            visitCount: 1,
          });
          console.log('New visitor logged with status "NEW" and visit count set to 1.');
        }
        // Set a flag in localStorage indicating visit logged
        localStorage.setItem('hasVisited', 'true');
      } catch (error) {
        console.error('Error logging visitor:', error);
      }
    };

    // Function to check if localStorage is supported and enabled
    const checkLocalStorage = () => {
      try {
        localStorage.setItem('test', 'test');
        localStorage.removeItem('test');
        return true;
      } catch (e) {
        return false;
      }
    };

    // Lifecycle hook to perform actions when the component is mounted
    onMounted(() => {
      if (checkLocalStorage()) {
      //  const hasVisited = localStorage.getItem('hasVisited');
      //  if (!hasVisited) {
          watch(
            () => !existenceLoading.value,
            (isLoaded) => {
              if (isLoaded && !existenceError.value) {
                logVisit();
              }
            }
          );
      //  }
      } else {
        showCookieWarning.value = true;
        watch(
          () => !existenceLoading.value,
          (isLoaded) => {
            if (isLoaded && !existenceError.value) {
              logVisit();
            }
          }
        );
      }
    });

    return {
      datetime,
      showCookieWarning,
    };
  },
};
</script>

<style scoped>
h1 {
  text-align: center;
  color: #333;
}

.cookie-warning {
  text-align: center;
  color: red;
  margin-top: 20px;
}
</style>
